// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SDNo","icon":"styles_icon__3ktsA"};